<template>
  <div>
    <label
      class="boss-pulldown-menu"
      for="boss-bigpulldown-menu-item"
    >
      <select
        id="boss-bigpulldown-menu-item"
        v-model="selectedSortId"
        class="boss-pulldown-menu-item"
        data-test="sort-select"
      >
        <option
          v-for="(sortItem ,i) in sortItemMap"
          :key="i"
          :data-test="'sort-option-' + i"
          :value="sortItem.id.toString()"
        >
          {{ sortItem.name }}
        </option>
      </select>
    </label>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  props: {
    objects: {
      type: Array,
      required: true
    },
    sortItemMap: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedSortId: 0,
      renderingObjects: this.objects
    }
  },
  watch: {
    selectedSortId: {
      handler: 'update'
    },
    objects: {
      handler (val) {
        if (this.renderingObjects !== val) {
          this.update()
        }
      }
    }
  },
  methods: {
    sortObjects (sorter) {
      return _.orderBy(this.objects, [
        (o) => {
          // 項目が未登録の場合（値がない）
          return !!(this.pickMaxValue(o, sorter.keys) + '')
        },
        (o) => {
          return this.pickMaxValue(o, sorter.keys)
        }],
      ['desc', sorter.order])
    },
    multipleSortObjects (sorter) {
      return _.orderBy(this.objects, [
        (o) => {
          // 項目が未登録の場合（値がない）
          return !!(this.pickMaxValue(o, sorter.keys) + '')
        },
        (o) => {
          return this.pickMaxValue(o, sorter.keys)
        },
        // 第２ソート
        (o) => {
          // 項目が未登録の場合（値がない）
          return !!(this.pickMaxValue(o, sorter.secondKeys) + '')
        },
        (o) => {
          return this.pickMaxValue(o, sorter.secondKeys)
        }],
      ['desc', sorter.order, 'desc', sorter.secondOrder])
    },
    pickMaxValue (object, keys) {
      return _.defaultTo(_(object).at(keys).max(), '')
    },
    update () {
      this.$set(this, 'renderingObjects', _.has(this.sortItemMap[this.selectedSortId], 'secondKeys')
        ? this.multipleSortObjects(this.sortItemMap[this.selectedSortId]) : this.sortObjects(this.sortItemMap[this.selectedSortId]))
      this.$emit('setObjects', this.renderingObjects)
    }
  }
}
</script>
